<template>
  <div class="rate-and-score">
    <div class="des">
      <!--出签率-->
      <div class="des1">
        <span class="span1">出签率</span>
        <span class="span2 red" v-text="successRate"></span>
        <span class="span3 red">%</span>
      </div>

      <!--评价-->
      <div class="des2">评价</div>
      <div class="des3">
        <stars :score="score"></stars>
      </div>
    </div>

    <!-- 下操作栏 -->
    <div class="method" id="method" v-on:click="popup">
      <div class="method-box">
        <div
          v-for="(item, index) in lessProcedure"
          :class="['img' + index]"
          :key="index"
        >
          <img :src="lessProcedure[index].icon" />
        </div>
        <div class="img3" v-if="procedure && procedure.length > 3">
          <img src="../../static/img/icon.png" />
        </div>
      </div>
    </div>

    <!-- 划出 -->
    <div class="pop" :class="[showPop ? 'popup' : 'popdown', 'popheader-move']">
      <div class="pop-header popheader-move">
        <img src="../../static/img/close@2x.png" v-on:click="popdown" />
        办理方式
      </div>
      <div class="pop-body">
        <div class="pop-list" v-for="(item, index) in procedure" :key="index">
          <img :src="procedure[index].icon" />
          <div v-text="procedure[index].title"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import stars from './stars';

export default {
  name: 'rateAndScore',
  props: {
    procedure: {
      type: Array,
    },
    passRate: {
      type: Number,
      default() {
        return 10000;
      },
    },
    reviews: {
      type: Number,
      default() {
        return 99;
      },
    },
    sumScore: {
      type: Number,
      default() {
        return 100;
      },
    },
  },
  data() {
    return {
      successRate: (Math.floor(this.passRate / 10) / 10)
        .toFixed(1)
        .replace('.0', ''),
      score: this.getScore(),
      lessProcedure:
        this.procedure.length >= 3
          ? this.procedure.slice(0, 3)
          : this.procedure.slice(0, this.procedure.length),
      showPop: false,
    };
  },
  methods: {
    getScore() {
      if (this.reviews && this.reviews !== 0) {
        return Number((this.sumScore / this.reviews).toFixed(1));
      }
      return 5;
    },

    popup() {
      this.showPop = true;
      const h = Math.max(
        document.body.scrollTop,
        document.documentElement.scrollTop,
      );
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `${-h}px`;
    },

    popdown() {
      this.showPop = false;
      const h = document.body.style.top;
      document.body.style.position = 'static';
      document.body.scrollTop = -parseInt(h);
    },
  },
  components: {
    stars,
  },
};
</script>
<style scoped>
.hidden {
  overflow: hidden;
}
.rate-and-score {
  width: 3.55rem;
  height: 1.3rem;
  background-color: #fff;
  margin: 0 auto;
  margin-top: -0.1rem;
}
.des {
  display: flex;
  height: 0.65rem;
  align-items: center;
}
.des div {
  display: inline-block;
  font-size: 0.14rem;
  color: #aaa;
}
.des3 div {
  display: flex;
}
.red {
  color: #ff5a60;
}
.des .des1 {
  margin-left: 0.38rem;
  text-align: center;
  display: flex;
  align-items: center;
}
.des1 .span1 {
  display: inline-block;
  line-height: 0.28rem;
}
.des1 .span2 {
  margin-left: 0.15rem;
  font-size: 0.24rem;
}
.des1 .span3 {
  padding-top: 0.07rem;
}
.des .des2 {
  margin-left: 0.6rem;
  position: relative;
}
.des3 {
  position: relative;
  width: 0.76rem;
  margin-left: 0.12rem;
}
.des3 .abs {
  position: absolute;
  width: 0.76rem;
  height: 0.12rem;
  top: 30%;
  left: 0;
  font-size: 0;
}
.des3 img {
  width: 0.12rem;
  height: 0.12rem;
  margin-left: 0.02rem;
}
.des .starlight {
  clip: rect(0px, 0.76rem, 0.12rem, 0px);
}
.des3 .count {
  margin: 0 auto;
  margin-top: 0.18rem;
  width: 100%;
  text-align: center;
}
.right {
  position: relative;
  margin-left: 0.03rem;
  width: 0.12rem;
  height: 0.12rem;
}
.right:after,
.right:before {
  content: '';
  border: 0.07rem solid transparent;
  border-left: 0.07rem solid #fff;
  width: 0;
  height: 0;
  top: 0;
  right: -0.05rem;
  position: absolute;
}
.right:before {
  border-left-color: #aaa;
  right: -0.07rem;
}
.method {
  width: 3.3rem;
  height: 0.65rem;
  margin: auto;
  position: relative;
  font-size: 0;
  border-top: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
}
.method div {
  display: inline-block;
}
.method .method-box {
  width: 2.78rem;
  display: block;
}
.method img {
  width: 0.32rem;
  height: 0.32rem;
}
.method .img0 {
}
.method .img1 {
  margin-left: 0.5rem;
}
.method .img2 {
  margin-left: 0.5rem;
}
.method .img3 {
  margin-left: 0.5rem;
}
.pop {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  background-color: rgba(255, 255, 255, 0.98);
  padding: 0.5rem 0 0 0;
  padding-bottom: 0.64rem;
  top: 100%;
}
.pop-body {
  overflow: auto;
  height: 100%;
  padding: 0 0.45rem;
  -webkit-overflow-scrolling: touch;
}
.popheader-move {
  transition: all 0.5s;
}
.popup {
  top: 0;
}

.popup .pop-header {
  top: 0;
}
.pop-header {
  position: fixed;
  margin-bottom: 0.12rem;
  height: 0.5rem;
  width: 100%;
  text-align: center;
  font-size: 0.2rem;
  left: 0;
  top: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}
.pop-header img {
  position: absolute;
  right: 0.13rem;
  top: 0.12rem;
  width: 0.24rem;
  height: 0.24rem;
}
.pop-list {
  font-size: 0.15rem;
  height: 0.7rem;
  border-bottom: 1px solid #f0f0f0;
}
.pop-list img {
  width: 0.32rem;
  height: 0.32rem;
  padding: 0.19rem 0;

  float: left;
}
.pop-list div {
  float: right;
  line-height: 0.7rem;
}
</style>
